var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apis from '@shared-app/lib/apis';
import { ValColumnEnum } from '@shared-app/lib/types';
export function downloadDwgFile(input, e) {
    return __awaiter(this, void 0, void 0, function* () {
        if (e)
            e.stopPropagation();
        try {
            const dwgPath = 'dwg_path' in input ? input.dwg_path : input[ValColumnEnum.dwg_path];
            const fileName = 'drawing_file_name' in input
                ? input.drawing_file_name
                : input[ValColumnEnum.drawing_file_name];
            if (!dwgPath)
                throw new Error('DWG path is missing');
            const res = yield (apis === null || apis === void 0 ? void 0 : apis.projects.getFilesDwg(dwgPath));
            let blob;
            if (res instanceof Blob) {
                blob = res;
            }
            else if (res === null || res === void 0 ? void 0 : res.data) {
                blob = new Blob([res.data], { type: 'application/acad' });
            }
            else if (res) {
                blob = new Blob([res], { type: 'application/acad' });
            }
            else {
                throw new Error('No valid file data found in response');
            }
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName ? `${fileName}.dwg` : 'drawing.dwg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (err) {
            console.error('Failed to download DWG:', err);
        }
    });
}
